// extracted by mini-css-extract-plugin
export default {"marquee":"ServicesMarquee_marquee__KxuYn"};